var _path, _path2, _path3, _rect, _ellipse, _ellipse2, _path4, _path5, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTruckScaleIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.0292 44.9785V78.2599C85.0292 79.2113 84.4409 79.9663 83.6973 79.9663H1.3158V85.6666H83.6973C86.8638 85.6666 89.4737 82.321 89.4737 78.2599V44.9785H85.0292Z",
    fill: "#29ABE2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.0129 33.6231C84.7564 33.3939 83.5973 32.2429 84.1455 30.6411C84.6469 29.1756 86.0625 28.9613 86.4602 29.0051C88.8677 29.2705 91.9545 33.059 93.2105 34.4819C91.2551 34.4819 86.4452 34.9035 85.0129 33.6231Z",
    fill: "#29ABE2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0004 16C79.8414 16 74 22.7392 74 30.9999C74 39.2607 79.8414 46 87.0004 46C94.1588 46 100 39.2607 100 30.9999C100 22.7391 94.1588 16 87.0004 16ZM87.0004 19.9795C92.2952 19.9795 96.5517 24.8905 96.5517 30.9999C96.5517 37.1093 92.2951 42.0204 87.0004 42.0204C81.7048 42.0204 77.4484 37.1094 77.4484 30.9999C77.4484 24.8905 81.7048 19.9795 87.0004 19.9795Z",
    fill: "#29ABE2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 62.8416,
    width: 80.2632,
    height: 9.72924,
    rx: 4,
    fill: "#29ABE2"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.0492,
    cy: 73.3816,
    rx: 6.44972,
    ry: 7.29693,
    fill: "#F7931E"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 65.2136,
    cy: 73.3816,
    rx: 6.44972,
    ry: 7.29693,
    fill: "#F7931E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4644 33.6538H70.3406L77.3967 48.2477V62.8415H54.4644V33.6538Z",
    fill: "#29ABE2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7639 38.5185H67.6943L71.6634 51.4908H58.7639V38.5185Z",
    fill: "#F7931E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.86658,
    y: 35.2753,
    width: 50.1645,
    height: 25.9446,
    rx: 8,
    fill: "#F7931E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11.4662,
    y: 32.0323,
    width: 8.59962,
    height: 3.24308,
    fill: "#29ABE2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckScaleIcon);
export default __webpack_public_path__ + "static/media/TruckScaleIcon.a844643ee5b46f7ce3fb1a863d86f22d.svg";
export { ForwardRef as ReactComponent };